import { render, staticRenderFns } from "./DriverFilters.vue?vue&type=template&id=20e0ffaa&scoped=true&"
import script from "./DriverFilters.vue?vue&type=script&lang=ts&"
export * from "./DriverFilters.vue?vue&type=script&lang=ts&"
import style0 from "./DriverFilters.vue?vue&type=style&index=0&id=20e0ffaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e0ffaa",
  null
  
)

export default component.exports